import DecorativeEllipse from "@/components/DecorativeEllipse";

const beforeItems = [
  "No sabés qué ofrecer / no tenés experiencia suficiente",
  "Vergüenza para cobrar o vender lo que hacés",
  "Esperás oportunidades en vez de salir a buscarlas",
  "Evitás mirar cuentas / desorden financiero / estrés",
];

const afterItems = [
  "Mapa de Valor completado: oferta en 1 frase + 3 paquetes listos",
  "Cobrás con confianza: precios definidos y negociación sin vergüenza",
  "Pipeline de oportunidades: contactos, mensajes y seguimiento semanal",
  "Presupuesto simple + hábito de 20 min para ordenar tu dinero",
];

export default function BeforeAfter() {
  return (
    <section className="relative overflow-hidden" style={{ backgroundColor: "#141414" }}>
      {/* Decorative ellipses */}
      <DecorativeEllipse
        className="-top-20 -left-20"
        size={400}
        opacity={0.12}
        blur={100}
      />
      <DecorativeEllipse
        className="-bottom-32 -right-24"
        size={500}
        opacity={0.10}
        blur={120}
      />

      {/* Gold gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-gold/[0.02] via-transparent to-gold/[0.03] pointer-events-none" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-center text-cream mb-12 md:mb-16">
          De esto… a esto
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {/* Antes */}
          <div className="group relative rounded-lg p-6 md:p-8 border border-dark-600 hover:border-cream/20 overflow-hidden transition-all duration-500" style={{ backgroundColor: "#1C1C1C" }}>
            {/* Subtle hover glow */}
            <div className="absolute inset-0 bg-gradient-to-br from-cream/[0.02] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none rounded-lg" />
            <div className="absolute top-0 right-0 w-40 h-40 opacity-5 pointer-events-none">
              <DecorativeEllipse className="top-0 right-0" size={160} opacity={1} blur={0} />
            </div>
            <div className="relative z-10 flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-500 group-hover:scale-110 group-hover:rotate-12" style={{ backgroundColor: "#3A3A3A" }}>
                <i className="ri-close-line text-cream/60 text-xl transition-colors duration-500 group-hover:text-cream/80" />
              </div>
              <h3 className="font-serif text-2xl md:text-3xl text-cream/60 transition-colors duration-500 group-hover:text-cream/80">
                Antes
              </h3>
            </div>
            <ul className="relative z-10 space-y-4">
              {beforeItems.map((item, index) => (
                <li key={index} className="flex items-start gap-3 transition-transform duration-500 group-hover:translate-x-1">
                  <span className="w-1.5 h-1.5 rounded-full mt-2 shrink-0 transition-colors duration-500 group-hover:bg-cream/40" style={{ backgroundColor: "#3A3A3A" }} />
                  <span className="font-sans text-sm md:text-base text-cream/50 leading-relaxed transition-colors duration-500 group-hover:text-cream/70">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Después */}
          <div className="group relative rounded-lg p-6 md:p-8 border border-gold/40 hover:border-gold/70 overflow-hidden transition-all duration-500" style={{ backgroundColor: "#1C1C1C" }}>
            {/* Gold gradient glow — brighter on hover */}
            <div className="absolute inset-0 bg-gradient-to-br from-gold/[0.06] via-transparent to-transparent pointer-events-none rounded-lg transition-all duration-500 group-hover:from-gold/[0.12]" />
            <div className="absolute -top-10 -right-10 w-52 h-52 opacity-[0.08] pointer-events-none">
              <DecorativeEllipse className="top-0 right-0" size={208} opacity={1} blur={0} />
            </div>
            <div className="relative z-10 flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full flex items-center justify-center border border-gold/50 transition-all duration-500 group-hover:scale-110 group-hover:border-gold group-hover:shadow-[0_0_20px_rgba(198,168,107,0.25)]">
                <i className="ri-check-line text-gold text-xl transition-all duration-500 group-hover:scale-110" />
              </div>
              <h3 className="font-serif text-2xl md:text-3xl text-gold transition-all duration-500 group-hover:drop-shadow-[0_0_8px_rgba(198,168,107,0.4)]">
                Después
              </h3>
            </div>
            <ul className="relative z-10 space-y-4">
              {afterItems.map((item, index) => (
                <li key={index} className="flex items-start gap-3 transition-all duration-500 group-hover:translate-x-1">
                  <span className="w-1.5 h-1.5 rounded-full mt-2 shrink-0 bg-gold transition-all duration-500 group-hover:shadow-[0_0_6px_rgba(198,168,107,0.5)]" />
                  <span className="font-sans text-sm md:text-base text-cream leading-relaxed transition-colors duration-500 group-hover:text-cream">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      {/* Divider */}
      <div className="relative z-10 h-px bg-gold-gradient" />
    </section>
  );
}